import { useTranslation } from 'react-i18next';
import { CreditCardAccessType } from '../../types/api/v2/obt/model/credit-card-access-type';
import { ListBookingPaymentSourcesRequestType } from '../../queries/payment';
import type { BookingPaymentSource } from '../../types/api/v2/obt/model/booking-payment-source';
import { PaymentSourceType } from '../../types/api/v2/obt/model/payment-source-type';

interface Props {
  bookingType: ListBookingPaymentSourcesRequestType;
  isPostPaid: boolean | undefined;
  primaryPaymentSource: BookingPaymentSource | undefined;
}

export const usePaymentSourceInfoText = ({ bookingType, isPostPaid, primaryPaymentSource }: Props) => {
  const { t: tt } = useTranslation('COMMON');
  let infoText = '';

  const isCentralCard =
    primaryPaymentSource?.type === PaymentSourceType.Card &&
    primaryPaymentSource?.paymentAccess?.creditCardAccess?.accessType === CreditCardAccessType.Centralised;

  if (bookingType === ListBookingPaymentSourcesRequestType.HOTEL && isPostPaid && isCentralCard) {
    infoText = tt('The hotel may require you to present a valid credit card at check-in.');
  } else if (bookingType === ListBookingPaymentSourcesRequestType.CAR && isPostPaid && isCentralCard) {
    infoText = tt('At the time of car pickup, you will need to present a valid credit card to the car rental company.');
  }

  return infoText;
};
